<p [outerHTML]="content?.richText"></p>
